export const profils = {
  1: {
    name: "Carole",
    avatar: "/images/1.png"
  },
  2: {
    name: "Sonia",
    avatar: "/images/2.png"
  },
  3: {
    name: "Sarah",
    avatar: "/images/3.png"
  },
  4: {
    name: "Alicia",
    avatar: "/images/4.png"
  },
  5: {
    name: "Tania",
    avatar: "/images/5.png"
  },
  6: {
    name: "Celine",
    avatar: "/images/6.png"
  },
  7: {
    name: "Ariane",
    avatar: "/images/7.png"
  },
  8: {
    name: "Ludivine",
    avatar: "/images/8.png"
  },
  9: {
    name: "Anne",
    avatar: "/images/9.png"
  },
  10: {
    name: "Alize",
    avatar: "/images/10.png"
  }
}; 